import React from "react";

export const ProductPage = () => {
    return (
       <div>
        San pham
       </div>
    )
}